import { Tooltip, Typography } from '@mui/material';
import React from 'react';

const ComplexityCell = React.memo(({ name }: { name: string | null | undefined }) => (
  <Tooltip arrow title={name || ''}>
    <Typography variant="body2" noWrap>
      {name || ''}
    </Typography>
  </Tooltip>
));

export default ComplexityCell;
